import getPercentage from './getPercentage'
import getPercentValue from './getPercentValue';

const setStroke = (path, points, totalPoints, update = false) => {
    let pathLength = (typeof path.getTotalLength === "function") ? path.getTotalLength() : 501.84271240234375;
    let value;

    path.setAttribute('stroke-dasharray', pathLength);

    if (update) {
        value = getPercentage(totalPoints, points);
        value = getPercentValue(value, pathLength);
        path.setAttribute('stroke-dashoffset', pathLength - value);
    } else {
        path.setAttribute('stroke-dashoffset', pathLength);
    }
}

export default setStroke;


// WEBPACK FOOTER //
// ./src/helpers/setStroke.js